var map = {
	"./puzzle9.jpg": "d2a7",
	"./puzzle9.mp3": "a99f",
	"./puzzle9_1.jpg": "cf6c",
	"./puzzle9_1.mp3": "b427",
	"./puzzle9_2.jpg": "4fd1",
	"./puzzle9_2.mp3": "0ce8",
	"./puzzle9_3.jpg": "934d",
	"./puzzle9_3.mp3": "364d",
	"./puzzle9_4.jpg": "0ad3",
	"./puzzle9_5.jpg": "ee04",
	"./puzzle9_5.mp3": "fbf2",
	"./puzzle9_6.jpg": "3db7",
	"./puzzle9_6.mp3": "5b85",
	"./puzzle9_7.jpg": "f2e7",
	"./puzzle9_8.jpg": "4013",
	"./puzzle9_8.mp3": "70f7",
	"./puzzle9_9.jpg": "b49f",
	"./puzzle9_b1.png": "0d82",
	"./puzzle9_b2.png": "08b6",
	"./puzzle9_b3.png": "b3b3",
	"./puzzle9_b4.png": "c2cb",
	"./puzzle9_b5.png": "1f42",
	"./puzzle9_b6.png": "9c1b",
	"./puzzle9_b7.png": "6499",
	"./puzzle9_b8.png": "8a84",
	"./puzzle9_b9.png": "b269"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2020";